import { Texture, TilingSprite as PixiTilingSprite } from 'pixi.js';

export default class TilingSprite {
  _image: HTMLImageElement | Texture | null = null;
  public tilingSprite: PixiTilingSprite;
  constructor(image: HTMLImageElement | Texture | null) {
    this._image = image;
    if (image instanceof HTMLImageElement) {
      this.tilingSprite = PixiTilingSprite.from(Texture.from(image));
    } else if (image instanceof Texture) {
      this.tilingSprite = PixiTilingSprite.from(image);
    } else {
      this.tilingSprite = PixiTilingSprite.from(Texture.EMPTY);
    }
  }
  set image(val: HTMLImageElement | Texture | null) {
    if (this._image === val) {
      return;
    }

    if (val instanceof HTMLImageElement) {
      this.tilingSprite.texture = Texture.from(val);
    } else if (val instanceof Texture) {
      this.tilingSprite.texture = val;
    }
    this._image = val;
  }
  get image() {
    return this._image;
  }
}
